import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { ChatHistoryPanel } from './components/ChatHistoryPanel';
import { ProjectsPanel } from './components/ProjectsPanel';
import { ChatArea } from './components/ChatArea';
import { mockChats, mockProjects } from './mockData';
export function App() {
  const [activeChatId, setActiveChatId] = useState<string | null>(null);
  const [isChatPanelOpen, setIsChatPanelOpen] = useState(false);
  const [isProjectsPanelOpen, setIsProjectsPanelOpen] = useState(false);
  const activeChat = activeChatId ? mockChats.find(c => c.id === activeChatId) || null : null;
  const handleNewChat = () => {
    setActiveChatId(null);
    setIsChatPanelOpen(false);
    setIsProjectsPanelOpen(false);
  };
  const handleSelectChat = (id: string) => {
    setActiveChatId(id);
  };
  const handleToggleChatPanel = () => {
    if (!isChatPanelOpen) {
      setIsProjectsPanelOpen(false);
    }
    setIsChatPanelOpen(!isChatPanelOpen);
  };
  const handleToggleProjectsPanel = () => {
    if (!isProjectsPanelOpen) {
      setIsChatPanelOpen(false);
    }
    setIsProjectsPanelOpen(!isProjectsPanelOpen);
  };
  return <div className="dark flex h-screen w-full bg-[#141620] text-slate-200 font-sans overflow-hidden" data-id="element-0">
      <Sidebar activeChatId={activeChatId} isChatPanelOpen={isChatPanelOpen} isProjectsPanelOpen={isProjectsPanelOpen} onToggleChatPanel={handleToggleChatPanel} onToggleProjectsPanel={handleToggleProjectsPanel} onNewChat={handleNewChat} data-id="element-1" />

      <ChatHistoryPanel isOpen={isChatPanelOpen} onClose={() => setIsChatPanelOpen(false)} chats={mockChats} projects={mockProjects} activeChatId={activeChatId} onSelectChat={handleSelectChat} data-id="element-2" />

      <ProjectsPanel isOpen={isProjectsPanelOpen} onClose={() => setIsProjectsPanelOpen(false)} projects={mockProjects} chats={mockChats} activeChatId={activeChatId} onSelectChat={handleSelectChat} data-id="element-3" />

      <main className="flex-1 flex flex-col h-full overflow-hidden bg-[#141620] relative z-10" data-id="element-4">
        <ChatArea activeChat={activeChat} data-id="element-5" />
      </main>
    </div>;
}